export const makeAutoEvaluable = (func: (...args: any[]) => any, ...args: any[]): string => {
  return `(${(<any>func).toString()})(${args.join(',')});`;
};

export const isNullOrUndefined = <T>(val: T | undefined | null): val is undefined | null => val === undefined || val === null;
